import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import EnvironmentService from '../services/environmentService';
import HttpBase from '../models/httpBase';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { RegistrationCodes } from '../models/registrationCodes';
import User from '../models/user';

import 'rxjs/add/operator/map';

@Injectable()
export default class RegistrationService extends HttpBase {

  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }

  registerUser(user: User, token: string): Observable<RegistrationCodes[]> {
    return this.httpPost(this.environmentService.registerUrl, {
      user,
      token
    }, true)
    .map((r: Response) => {
      if (r.status === 422) {
        return r.json().errorCodes;
      }

      const okCode: RegistrationCodes[] = [RegistrationCodes.ok];

      // return Array<RegistrationCodes>(RegistrationCodes.ok);
      return okCode;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/registrationService.ts